import { render, staticRenderFns } from "./MaskPack.vue?vue&type=template&id=72487efe&scoped=true"
import script from "./MaskPack.vue?vue&type=script&lang=js"
export * from "./MaskPack.vue?vue&type=script&lang=js"
import style0 from "./MaskPack.vue?vue&type=style&index=0&id=72487efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72487efe",
  null
  
)

export default component.exports